import { useState } from 'react';

import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';
import { User } from 'types/embedded/user';

import { UsersCreateForm } from './UsersCreateForm';

export const UsersCreate = (): JSX.Element => {
  const [hasCorporateEmail, setHasCorporateEmail] = useState(false);

  const transform = (data: User) => {
    return {
      ...data,
      corporateEmail: hasCorporateEmail ? data.corporateEmail : null,
      roleEntities: data.roleEntities,
    };
  };

  return (
    <CreateGuesserPage
      listName="Пользователи"
      mutationOptions={{ onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButtonValidated key="save-buttton" label="Создать" />,
      ]}
      title="Создание пользователя"
      transform={transform}
    >
      <UsersCreateForm
        hasCorporateEmail={hasCorporateEmail}
        setHasCorporateEmail={setHasCorporateEmail}
      />
    </CreateGuesserPage>
  );
};
